import * as React from "react"
import {TabsSeeker} from "@ui-seeker/core";

import { DISPLAY_TABS } from "./@constants";


const TABS = [
	{label: 'Top 20 Price Changes', value: DISPLAY_TABS.PRICE_CHANGES},
	{label: 'Top 20 Stock Changes', value: DISPLAY_TABS.STOCK_CHANGES}
]

export default function PriceTopMarketChangesTabs({ value, onChange }) {
    return <TabsSeeker
		tabs={TABS}
		value={value}
		onChange={onChange}
	/>
}